import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import coreReducer from './reducer';
import coreSagas from './sagas';

const sagaMiddleware = createSagaMiddleware();

export const initialState = {
  analytics: {
    gtag: false,
    tealium: false,
  },
  bundles: {},
  configs: {},
  data: {},
  dialogs: {
    open: false,
    params: null,
    type: null,
  },
  fields: {},
  groups: {},
  home: {},
  offers: {},
  page: {
    name: null,
    recaptchaEnabled: false,
  },
  progress: [],
  refs: {
    appIds: null,
    appRequestId: null,
    market: null,
    product: null,
    status: null,
  },
  resources: {},
  session: {
    meta: {
      configs: {
        locale: 'en-US',
      },
    },
  },
  theme: {},
  timeOut: {
    reset: 0,
  },
  ui: {
    activeGroup: null,
    activePanel: null,
    appLoading: true,
    appRequestId: null,
    campaign: null,
    content: null,
    didStartAutoexport: false,
    didStartQualify: false,
    emailToken: null,
    errorPage: '',
    existing: null,
    fieldFocus: null,
    fieldLoading: null,
    groupLoading: false,
    hasTheme: process.env.REACT_APP_ENV === 'test',
    market: null,
    medium: null,
    menuOpen: false,
    page: null,
    pageLoading: false,
    prefillToken: null,
    product: null,
    restart: null,
    source: null,
    term: null,
    token: null,
  },
};

// eslint-disable-next-line
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  coreReducer,
  initialState,
  composeEnhancers(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(coreSagas);

export default store;
